import { MapUiTheme } from '../../common';

export const appBarTheme = {
  defaultStyles: (theme: MapUiTheme) =>
    ({
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      backgroundColor: theme.colors.white,
    } as const),
  normal: {},
  trasparent: {
    backgroundColor: 'transparent',
  },
  border: (theme: MapUiTheme) => ({
    border: '1px solid ' + theme.colors.grey300,
  }),
};
